import React from 'react';
import Logo from 'images/microsoft_icon.png';

export const MicrosoftLoginButton = ({ onClick })  => {
    return (
        <div
            className='text-center flex justify-center align-center'
            style={{ marginBottom: '15px', border: '1px solid #d8dbe0', height: '35px', cursor: "pointer" }}
            onClick={onClick}
        >
            <img
                src={Logo}
                alt="Login with Microsoft"
                style={{ marginRight: '7px', width: 18, height: 18 }}
            />

            <span style={{ color: '#7C7C7C', fontSize: 14, fontWeight: 500 }}>Sign in with Microsoft</span>
        </div>
    );
}
